export default "__VITE_ASSET__6549fd81__"